import { render, staticRenderFns } from "./PrivacyChannel.vue?vue&type=template&id=96626fea&scoped=true&"
import script from "./PrivacyChannel.vue?vue&type=script&lang=js&"
export * from "./PrivacyChannel.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyChannel.vue?vue&type=style&index=0&id=96626fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96626fea",
  null
  
)

export default component.exports